<template>
  <div class="nav">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/logo.png">
          <span>Frogero</span>
        </router-link>
      </div>

      <div class="options">

        <div class="text">Personal speaking trainer</div>

      </div>

      <div class="buttons">
        <div class="login-box" v-if="!TokenState || showSingup">
          <button @click="login">Log in</button>
        </div>
        <div class="singup-box" v-if="!TokenState || showSingup">
          <button @click="singup">Sign up</button>
        </div>

        <div class="option" v-if="TokenState && !showSingup" @click="goMain">
          <div class="icon-box">
            <font-awesome-icon :icon="['fas', 'stream']" class="icon" />
          </div>
          <div class="label-box">
            Dialogues
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      showSingup: false
    }
  },
  methods: {
    login() {
      this.$emit('login');
    },
    singup() {
      this.$emit('singup');
    },
    goMain() {
      this.$router.push('/main').then(() => {
      }).catch(() => {
        this.showSingup = true;
      })
    }
  },
  computed: {
    TokenState() {
      if(localStorage.getItem('token') != null) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500;600&display=swap');

.nav {
  width: 100%;
  height: 5rem;
  background-color: #11b6a5;
  display: flex;
  justify-content: center;

  .container {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: row;

    @media (max-width: 1200px) {
      width: 90%;
    }
    @media (max-width: 1050px) {
      width: 95%;
    }
    @media (max-width: 900px) {
      width: 80%;
    }
    @media (max-width: 600px) {
      width: 90%;
    }

    .logo {
      width: 10rem;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 1.8rem;

      img {
        width: 2.2rem;
        margin-top: 0.1rem;
      }

      span {
        margin-left: 0.8rem;
        font-family: 'Oswald';
      }

      a {
        text-decoration: none;
        color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }

    .options {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;

      .text {
        height: 2.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 1.4rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 0.3rem;
        @media (max-width: 850px) {
          font-size: 1.2rem;
        }
        @media (max-width: 850px) {
          font-size: 1rem;
        }
        @media (max-width: 700px) {
          display: none;
        }
      }
    }

    .buttons {
      width: 14rem;
      height: 100%;
      display: flex;
      flex-direction: row;
      margin-left: auto;
      align-items: center;
      justify-content: flex-end;

      @media (max-width: 400px) {
        width: 10rem;
      }

      .login-box {
        width: 6rem;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (max-width: 400px) {
          width: 5rem;
        }

        button {
          font-size: 1.1rem;
          color: white;
          border: none;
          background: none;
          outline: none;
          font-weight: bold;
          transition: 0.2s;

          &:hover {
            cursor: pointer;
            opacity: 0.6;
          }
        }
      }

      .singup-box {
        width: 8rem;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (max-width: 400px) {
          width: 5rem;
        }

        button {
          width: 8rem;
          height: 2.5rem;
          font-size: 1.1rem;
          color: white;
          font-weight: bold;
          border: none;
          outline: none;
          background-color: #e6c17d;
          border-radius: 0.3rem;
          transition: 0.2s;

          @media (max-width: 400px) {
            width: 6rem;
          }

          &:hover {
            cursor: pointer;
            background-color: #cfae71;
          }
        }
      }

            .option {
        width: auto;
        height: 2.5rem;
        display: flex;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        transition: 0.3s;

        .icon-box {
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            color: white;
            font-size: 1.3rem;
          }
        }

        .label-box {
          width: auto;
          height: 2.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-left: 0.2rem;
          padding-right: 0.5rem;
          color: white;
          font-size: 1.3rem;
          font-weight: bold;

          @media (max-width: 400px) {
            display: none;
          }
        }

        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }

    }
  }
}
</style>